import Vue from 'vue';
export default {
  getterToken(state) {
    return state.doctorToken || Vue.prototype.$session.fetch('doctorToken');
  },
  getterVideoPatient(state) {
    return state.reservePatientList || Vue.prototype.$session.fetch('reservePatientList');
  },
  getterLoginPhone(state) {
    return state.loginPhone || Vue.prototype.$session.fetch('loginPhone');
  },
  getterCameraStatus(state) {
    return state.isHasCamera || Vue.prototype.$session.fetch('isHasCamera');
  }
}


// WEBPACK FOOTER //
// ./src/store/common/getters.js